<!-- FooterContent.vue -->
<template>
  <footer class="bg-[#00395a] text-gray-300 pt-16 pb-8">
    <div class="max-w-[100rem] mx-auto px-4 sm:px-6 lg:px-16">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
        
        <!-- Organization Info / Logo -->
        <div class="mb-6 md:mb-0">
          <a href="/" class="flex items-center mb-4">
            <!-- You can place your logo here -->
            <!-- <img src="@/assets/sglm-logo-footer.png" alt="SGLM Logo" class="h-12 mr-3"> -->
            <span class="text-2xl font-bold text-white">Shree Ghoghari Lohana Mahajan</span>
          </a>
          <p class="text-sm leading-relaxed">
            Serving the community since 1854. Dedicated to the welfare and upliftment of the Ghoghari Lohana community.
          </p>
        </div>

        <!-- Quick Links -->
        <div>
          <h5 class="text-lg font-semibold text-white mb-4">Quick Links</h5>
          <ul class="space-y-2">
            <li><a href="/about" class="hover:text-white transition-colors duration-300">About Us</a></li>
            <li><a href="/services" class="hover:text-white transition-colors duration-300">Services</a></li>
            <li><a href="/events" class="hover:text-white transition-colors duration-300">Events</a></li>
            <li><a href="/donations" class="hover:text-white transition-colors duration-300">Donations</a></li>
            <li><a href="/contact" class="hover:text-white transition-colors duration-300">Contact Us</a></li>
          </ul>
        </div>

        <!-- Contact Information -->
        <div>
          <h5 class="text-lg font-semibold text-white mb-4">Contact Us</h5>
          <address class="not-italic space-y-2 text-sm">
            <p>
              <strong class="text-gray-100">Address:</strong><br>
              Shree Ghoghari Lohana Mahajan<br>
                  Ground Floor, Lohana Bhuvan,<br>
                  Paliram Road, Andheri (West),<br>
                  Mumbai – 400 058, Maharashtra, India.
            </p>
            <p>
              <strong class="text-gray-100">Phone:</strong> <a href="tel:+91 99872 40404" class="hover:text-white transition-colors duration-300">+91 99872 40404</a>
            </p>
            <p>
              <strong class="text-gray-100">Email:</strong> <a href="mailto:contact@sglm.in" class="hover:text-white transition-colors duration-300">contact@sglm.in</a>
            </p>
          </address>
        </div>

        <!-- Social Media & Newsletter (Optional) -->
        <div>
          <h5 class="text-lg font-semibold text-white mb-4">Follow Us</h5>
          <div class="flex space-x-4 mb-6 items-center justify-center">
            <a href="#" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition-colors duration-300" aria-label="Facebook">
              <!-- Replace with actual SVG icon -->
              <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition-colors duration-300" aria-label="Instagram">
              <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.059 1.689.073 4.948.073 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948s-.014-3.667-.072-4.947c-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.948-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            </a>
            <!-- <a href="#" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition-colors duration-300" aria-label="Twitter">
              <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-.422.724-.665 1.56-.665 2.452 0 1.613.823 3.043 2.074 3.873-.766-.024-1.483-.233-2.11-.583v.06c0 2.254 1.605 4.134 3.737 4.568-.39.107-.803.164-1.227.164-.3 0-.593-.028-.877-.082.593 1.844 2.313 3.186 4.354 3.224-1.595 1.248-3.604 1.992-5.786 1.992-.376 0-.747-.022-1.112-.065 2.062 1.323 4.51 2.093 7.14 2.093 8.572 0 13.255-7.098 13.255-13.254 0-.202-.005-.403-.014-.603.91-.658 1.7-1.475 2.323-2.408z"/></svg>
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition-colors duration-300" aria-label="LinkedIn">
              <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/></svg>
            </a> -->
          </div>
         
        </div>

      </div>

      <!-- Bottom Bar -->
      <div class="border-t border-gray-700 pt-8 text-center">
        <p class="text-sm">
          &copy; {{ new Date().getFullYear() }} Shree Ghoghari Lohana Mahajan, Mumbai. All Rights Reserved.
        </p>
        <p class="text-xs mt-1 text-gray-500">
          Designed & Developed with <span class="text-red-500">&hearts;</span> by <a href="https://turinix.com" target="_blank" rel="noopener noreferrer" class="hover:text-white">Turinix</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterContent',
  // You can add data, methods, etc. here if needed for more dynamic content
}
</script>

<style scoped>
/* You can add component-specific styles here if absolutely necessary, 
   but prefer Tailwind utility classes for consistency. */
</style>